export const vehicleActionStyles = {
  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginBottom: '10px',
  },
  datePicker: {
    width: '100%',
  },
};

export const vehicleListItemStyles = {
  divider: {
    width: '100%',
    height: '1px',
    margin: '10px 0',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
  },
  container: {
    'display': 'flex',
    'flexDirection': 'column',
    'cursor': 'pointer',
    '&:hover': {
      background: '#fafafa',
    },
    'borderRadius': '10px',
    'padding': '10px',
  },
  deleted: {
    'background': 'rgba(165, 42, 42, 0.1)',
    '&:hover': {
      background: 'rgba(165, 42, 42, 0.2)',
    },
  },
  header: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '10px',
    gap: { xs: '5px', sm: '0' },
  },
  name: {
    fontWeight: 'bold',
    fontSize: '1.05rem',
    textTransform: 'uppercase',
  },
  detailsOuterContainer: {
    display: 'flex',
    gap: '15px',
    alignItems: 'center',
  },
  photoContainer: {
    display: 'flex',
    width: { xs: '30%', sm: '10%' },
    minWidth: '10%',
    maxWidth: '200px',
    height: '80px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  detailsContainer: {
    display: 'flex',
    flexGrow: '1',
    gap: '15px',
    justifyContent: 'space-between',
  },
  detailsColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  detailContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  detailTitle: {
    textTransform: 'uppercase',
    color: '#777',
    fontSize: '0.75rem',
    fontWeight: 'bolder',
  },
  detailValue: {
    fontWeight: 'bold',
  },
  comment: {
    display: '-webkit-box',
    maxWidth: '200px',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
};

export const vehicleStatusStyles = {
  container: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    justifyContent: { xs: 'space-between', sm: 'normal' },
    width: { xs: '100%', sm: 'auto' },
  },
  name: {
    fontWeight: 'bold',
    fontSize: '0.8rem',
    textTransform: 'uppercase',
  },
  progressBarOuter: {
    width: { xs: '130px', sm: '200px' },
    height: '10px',
    borderRadius: '25px',
    backgroundColor: '#eeeeee',
  },
  progressBarInner: {
    height: '100%',
    borderRadius: '25px',
  },
};
